// 列名称映射配置
export const COLUMN_NAMES: Record<string, Record<string, string>> = {
  'fee-management': {
    'user_id': '所属用户',
    'nation': '国家',
    'service': '业务类型',
    'sub_service': '子业务',
    'submit_channel': '递交渠道',
    'contact_info': '联系方式',
    'category_type': '制度',
    'fee_official': '官费',
    'fee_service': '服务费',
    'fee_inquiry': '查询费',
    'fee_notarization': '公证费',
    'fee_cost': '成本',
    'fee_profit': '毛利润',
    'fee_peer': '同行报价',
    'dates_submit': '递交周期',
    'dates_complete': '完成周期',
    'documents': '文档',
    'remark': '备注',
    'created_at': '添加时间',
    'updated_at': '更新时间',
  },
  'follow-up-management': {
    'user_id': '所属用户',
    'nation': '国家',
    'service': '业务类型',
    'sub_service': '子业务',
    'client_type': '客户等级',
    'source': '来源',
    'contact_name': '联系人',
    'contact_info': '联系方式',
    'intent': '意向度',
    'status': '状态',
    'latest_record': '最新跟进记录',
    'remark': '备注',
    'created_at': '添加时间',
    'updated_at': '更新时间',
  },
  'trademark-monitor': {
    'user_id': '所属用户',
    'user_email': '邮箱',
    'application_no': '申请号',
    'registration_no': '注册号',
    'trademark_name': '商标名称',
    'nation': '国家',
    'name': '商标名称',
    'image': '商标图样',
    'primary_class': '大类',
    'sub_class': '小类',
    'tags': '标签',
    'history': '历史状态',
    'documents': '文档',
    'owner_name': '申请人',
    'owner_username': '所属用户名',
    'attorney_name': '代理律师',
    'attorney_email': '代理律师邮箱',
    'correspondent_name_address': '通讯人',
    'correspondent_email': '通讯邮箱',
    'remote_status': '商标局状态',
    'status': '状态',
    'condition': '是否正常',
    'application_at': '申请日期',
    'due_at': '截止日期',
    'expiration_at': '到期日',
    'status_updated_at': '状态更新日期',
    'sync_at': '上次抓取日期',
    'next_update_at': '预计下次更新',
    'approve_at': '注册日期',
    'created_at': '添加时间',
    'updated_at': '更新时间',
  },
  'document-management': {
    'user_id': '所属用户',
    'nation': '国家',
    'files': '文件',
    'name': '文档名',
    'remark': '备注',
    'file_type': '文件类型',
    'order_no': '订编号',
    'owner_name': '所属用户名',
    'media_files': '媒体文件',
    'service_type': '服务类型',
    'file_size': '文件大小',
    'upload_at': '上传时间',
    'created_at': '添加时间',
    'updated_at': '更新时间',
  },
  'order-management': {
    // 基础与订单字段
    'id': 'ID',
    'order_type': '订单类型',
    'parent_id': '父订单ID',
    'service': '业务类型',
    'sub_service': '子业务名称',
    'nation': '国家',
    'order_no': '订单编号',
    'case_no': '案件编号',
    'application_entity_type': '申请主体类型',
    'applicant_name': '申请人',
    'applicant_address': '申请人地址',
    'applicant_name_en': '申请人英文名',
    'applicant_address_en': '申请人英文地址',
    'status': '状态',
    'files': '附件',

    // 日期相关
    'due_at': '截止日期',
    'expiration_at': '异常日期',
    'announcement_at': '公告日期',
    'receipt_at': '回执日期',
    'decline_at': '驳回日期',
    'approve_at': '注册日期',
    'created_at': '创建时间',
    'updated_at': '更新时间',

    // 客户与渠道
    'client_id': '客户ID',
    'client_email': '客户邮箱',
    'contact_name': '客户名称',
    'client_type': '客户等级',
    'group_number': '客户群号',
    'channel': '渠道',
    'source': '来源',

    // 财务
    'payment_status': '付款状态',
    'payment_at': '付款时间',
    'next_status': '下个状态',
    'price': '成交价格',
    'cost': '成本',
    'profit': '毛利润',
    'seller': '所属销售',
    'commission': '提成金额',

    // 商标扩展
    'primary_class': '类别',
    'application_no': '申请号',
    'owner_name': '申请人/最新权利人',
    'sub_class': '小类',
    'trademark_name': '商标名称',
    'trademark_status': '商标状态',
    'registration_no': '注册号',
    'sale_status': '出售状态',
    'sold_at': '出售时间',
    'trademark_type': '商标类型',
    'application_basics': '申请基础',
    'a1_first_use_at': '首次使用日期',
    'a1_first_commercial_use_at': '首次商用日期',
    'b44_registration_no': '44(e)注册号',
    'b44_registration_at': '44(e)注册日期',
    'd44_application_no': '44(d)申请号',
    'd44_application_at': '44(d)申请日期',
    'priority': '优先权',
    'priority_no': '优先权号',
    'priority_date': '优先权日期',
    'base_country_trademark_name': '基础国商标名',
    'base_country_application_no': '基础国申请号',
    'base_country_registration_no': '基础国注册号',
    'international_registration_no': '国际注册号',
    'trademark_meaning': '商标含义',
    'color_statement': '颜色声明',
    'assignee_entity_type': '受让人主体类型',
    'assignee_name': '受让人名称',
    'assignee_address': '受让人地址',
    'assignee_name_en': '受让人英文名',
    'assignee_address_en': '受让人英文地址',
    'new_applicant_name': '变更后名字',
    'new_applicant_address': '变更后地址',
    'new_applicant_name_en': '变更后英文名字',
    'new_applicant_address_en': '变更后英文地址',
    'include_transfer_service': '含转让服务',
    'assignment_type': '转让类型',
    'postpone_type': '延期类型',
    'postpone_times': '延期次数',
    'postpone_reason': '延期原因',
    'review_type': '复审类型',
    'review_times': '复审次数',
    'rationale_basis': '理由基础',
    'revocation_type': '撤销类型',
    'search_method': '检索方式',
    'oath_type': '宣誓类型',
    'renewal_period': '续展期次',
    'original_agent': '原代理人',
    'cancellation_reason': '注销原因',
    'certificate_type': '证书类型',
    'change_items': '变更项目',
    // 专利扩展
    'patent_name': '专利名称',
    'entity_type': '实体类型',
    'include_drawing': '包含制图',
    'accelerated': '加速申请',
    'include_authorization': '包含授权服务',
    'include_translation': '专利翻译',
    'inventor': '发明人',
    'inventor_name': '发明人名称',
    'inventor_address': '发明人地址',
    'inventor_name_en': '发明人英文名',
    'inventor_address_en': '发明人英文地址',
    'open_status': '公开状态',
    'opened_at': '公开日期',
    'opened_area': '公开国家和城市',
    'opened_type': '公开方式',
    'claims_count': '权利要求数量',
    'exceeding_quantity': '超出数量',
    'include_document_writing': '包含撰写',
    'patent_type': '专利类型',
    'appearance_name': '外观名称',
    'review_type_patent': '复审类型',
    'rejection_reason': '驳回原因',
    'postpone_times_patent': '复审次数',
    // 版权扩展
    'copyright_registration_no': '注册号',
    'work_name': '作品名称',
    'application_type': '申请方式',
    'application_category': '作品类型',
    'work_inspiration': '作品来源及灵感',
    // 公司扩展
    'company_no': '公司编号',
    'company_name': '公司名称',
    'company_address': '公司地址',
    'company_type': '公司类型',
    'legal_representative': '法人代表',
    'include_vat_no': '含税号',
    'include_bank_account': '含开户',
    'include_foreign_directors': '需要外籍董事',
    'annual_inspection_times': '年审次数',
    'account_bank': '开户银行',
    'cancellation_reason_company': '注销原因',
    'change_items_company': '变更项目',
    // 条形码扩展
    'company_name_barcode': '公司名称',
    'quantity_barcode': '数量',
    'validity_period': '有效期限',
    'renewal_period_barcode': '续费周期',
    'cancellation_reason_barcode': '注销原因',
    'quantity_original': '原始数量',
    'quantity_increase': '本次增加数量',
    // 通知模板变量专用字段
    'trademark_image': '商标图样',
    'year': '缴费年份',
    'started_at': '开始日期',
    'grace_at': '宽限日期',
    'query_link': '查看链接',
    'contact_person': '客服联系人',
    'contact_phone': '联系电话',
    'application_at': '申请日期',
    'status_updated_at': '同步日期',
    'next_update_at': '预计下次更新',
    // 其他
    'service_name': '业务名',
  },
  'status-translation': {
    'english': '英文状态',
    'chinese': '中文翻译',
    'original_status': '原始状态',
    'translated_status': '翻译状态',
    'status_type': '状态类型',
    'description': '描述',
    'created_at': '创建时间',
    'updated_at': '更新时间'
  }
};

// 获取列的显示名称
export const getColumnDisplayName = (pageKey: string, columnKey: string): string => {
  return COLUMN_NAMES[pageKey]?.[columnKey] || columnKey;
};

// 获取带格式的列名称：中文名称(英文key)
export const getColumnDisplayLabel = (pageKey: string, columnKey: string): string => {
  const displayName = getColumnDisplayName(pageKey, columnKey);
  return displayName === columnKey ? columnKey : `${displayName}(${columnKey})`;
};

// 操作权限名称映射
export const ACTION_NAMES: Record<string, string> = {
  'create': '添加',
  'edit': '编辑',
  'delete': '删除',
  'export': '导出',
  'import': '导入',
  'monitor': '监控',
  'update_status': '更新状态',
  'copy': '复制',
  'view_details': '查看详情',
  'download': '下载',
  'upload': '上传',
  'save': '保存',
  'reset': '重置',
  'view_overview': '查看概览'
};

// 表单字段名称映射
// 大部分字段与 COLUMN_NAMES 一致，只需定义差异部分
const FORM_FIELD_OVERRIDES: Record<string, Record<string, string>> = {
  'fee-management': {

  },
  'follow-up-management': {

  },
  'trademark-monitor': {
  },
  'document-management': {
  },
  'order-management': {
    // 订单管理表单字段与列名基本一致，无需覆盖
  },
  'status-translation': {
    // 状态翻译表单字段与列名一致
  }
};

// 动态生成 FORM_FIELD_NAMES，复用 COLUMN_NAMES 并应用覆盖
export const FORM_FIELD_NAMES: Record<string, Record<string, string>> = Object.keys(COLUMN_NAMES).reduce((acc, pageKey) => {
  acc[pageKey] = {
    ...COLUMN_NAMES[pageKey],
    ...(FORM_FIELD_OVERRIDES[pageKey] || {})
  };
  return acc;
}, {} as Record<string, Record<string, string>>);

// 获取操作的显示名称
export const getActionDisplayName = (actionKey: string): string => {
  return ACTION_NAMES[actionKey] || actionKey;
};

// 获取页面内操作权限显示名称，用于同一 action key 在不同页面语义不同的场景
export const getPageActionDisplayName = (pageKey: string, actionKey: string): string => {
  if (pageKey === 'trademark-monitor' && actionKey === 'update_status') {
    return '同步状态';
  }

  return getActionDisplayName(actionKey);
};

// 获取表单字段的显示名称
export const getFormFieldDisplayName = (pageKey: string, fieldKey: string): string => {
  return FORM_FIELD_NAMES[pageKey]?.[fieldKey] || fieldKey;
};

/**
 * 获取列标题（用于通知模板变量等场景）
 * 优先从 order-management 查找，如果没有则从 trademark-monitor 查找
 */
export const getColumnTitle = (columnKey: string): string | undefined => {
  // 优先从订单管理中查找
  const orderTitle = COLUMN_NAMES['order-management']?.[columnKey];
  if (orderTitle) {
    return orderTitle;
  }

  // 其次从商标监控中查找
  const trademarkTitle = COLUMN_NAMES['trademark-monitor']?.[columnKey];
  if (trademarkTitle) {
    return trademarkTitle;
  }

  // 返回 undefined 表示未找到
  return undefined;
};

export default COLUMN_NAMES;
